import {
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import { DatasetMetadata } from './dataset-model';
import store from './dataset-store';

@Module({
  dynamic: true,
  namespaced: true,
  name: 'DatasetModule',
  store,
})
class DatasetModule extends VuexModule {
  private _isLoading = false;
  private _metadata: DatasetMetadata | null = null;

  public get metadata(): DatasetMetadata | null {
    return this._metadata;
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get hasLoaded(): boolean {
    return this._metadata !== null;
  }

  @Mutation
  updateMetadata(metadata: DatasetMetadata): void {
    this._metadata = metadata;
  }

  @Mutation
  updateLoading(isLoading: boolean): void {
    this._isLoading = isLoading;
  }
}

export default getModule(DatasetModule);
